import { createContext, useContext } from 'react';

import { CallController } from '@gem/call/CallController/CallController';
import { Call } from '@gem/call/CallStore/Call';

export interface ICallContext {
  call: Call;
  callController: CallController;
}

export const CallContext = createContext<ICallContext>({} as ICallContext);

export const useCallContext = (): ICallContext => {
  return useContext(CallContext);
};

export const CallPopupContext = createContext<ICallContext>({} as ICallContext);
